<template>
  <div>
    <v-card height="64px" width="100%"
      class="background ml-4 mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
      style="position:fixed; z-index:200; top:0; width: 98%; padding-top: 16px;">
      <v-card-title class="pl-0 ml-0">
        <p class="breadcrumb-text-unselected underline-on-hover cursor" @click="$router.push('/masters')">
          Masters
        </p>
        <v-icon class="breadcrumb-arrow-unselected" style="margin-top: 6px !important">mdi-chevron-right</v-icon>
        <v-menu offset-y class="menuZindex">
          <template v-slot:activator="{ on }">
            <span v-on="on" class="breadcrumb-text" style="margin-top: 2px">
              Learning Objectives
              <v-icon class="breadcrumb-arrow cursor" style="margin-top: 5px !important">mdi-chevron-down</v-icon>
            </span>
          </template>
          <MastersDropdownComponent />
        </v-menu>

        <!-- <p class="breadcrumb-text" style="margin-top: 2px">LO Bank</p>
        <v-icon class="breadcrumb-arrow" style="margin-top: 5px !important">mdi-chevron-down</v-icon> -->
      </v-card-title>
      <div class="size-menu d-flex flex-row justify-start pr-4  w-fit align-center" style="position: fixed; right: 0;">
        <v-badge color="red" dot right transition="slide-x-transition" class="mr-8">
          <v-hover>
            <img class="cursor" @click="notificationDialog = true" src="../../assets/bell 1.svg">
          </v-hover>
        </v-badge>

        <div>

          <img src="../../assets/avtar.png" class="rounded-xl mr-2" width="32" height="32">

        </div>
        <div class="d-flex flex-column d-justify-evenly user-details">
          <v-card-title class="ma-0 pa-0 elipsis">
            {{ $store.state.userInfo.name }}
          </v-card-title>
          <v-card-subtitle class="accent--text ma-0 pa-0 elipsis">
            {{ $store.state.userInfo.email }}
          </v-card-subtitle>
        </div>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn width="40px" height="40px" color="primary" dark v-bind="attrs" v-on="on" icon>
              <v-icon class="">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-btn @click="logout">logout</v-btn>
        </v-menu>
      </div>
    </v-card>
    <div fluid class="px-8 pad">

      <v-row>
        <v-col>

          <v-dialog max-width="887px" class="cdz" v-model="dialog" center>
            <v-form ref="form" lazy-validation>
              <v-card>
                <v-card-title class="primary mb-8">{{ formbtn() }} Learning Objective</v-card-title>
                <v-card-text class="px-6 pb-0">
                  <v-row class="py-0">
                    <v-col class="py-0" cols="3">
                      <v-text-field outlined class="rounded-xl" v-model="lOCode" label="LO Code *"
                        @keypress="filter(event)" :rules="[v => !!v || 'LO Code is required']" required></v-text-field>
                    </v-col>
                    <v-col class="py-0" cols="9">
                      <v-text-field outlined class="rounded-xl" v-model="title" label="LO Title *"
                        :rules="[v => !!v || 'LO Title is required']" required></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="py-0">
                    <v-col class="py-0">
                      <v-text-field outlined class="rounded-xl" v-model="description" label="Description"></v-text-field>
                    </v-col>
                  </v-row>

                </v-card-text>

                <v-card-actions class="px-6 pb-6">
                  <small>*All fields are mandatory</small>
                  <v-spacer></v-spacer>
                  <v-btn width="102px" height="48px" rounded outlined class="accent--text pa-4"
                    @click="dialog = false">Cancel</v-btn>
                  <v-btn width="102px" height="48px" rounded @click="saveInputs" class="accent pa-4" :loading="loading">{{
                    formbtn()
                  }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>

          </v-dialog>
        </v-col>
        <!-- <v-col cols="4">
        <v-text-field label="Search" prepend-inner-icon="mdi-magnify" clearable v-model="search"></v-text-field></v-col> -->
      </v-row>
      <v-row class="d-flex justify-center my-0 py-0">
        <v-col>
          <div class="text-h6">LO Bank</div>
        </v-col>

        <v-col cols="10" class="pl-0 ml-0">
          <v-row justify="end" class="mb-1 mt-0">
            <v-text-field solo label="Search here..." prepend-inner-icon="mdi-magnify" v-model="search" hide-details
              class="search-bar border-button rounded-pill mx-3" dense clearable></v-text-field>
            <!-- <v-btn depressed rounded outlined class="border-button mx-3"><v-icon>mdi-tune</v-icon>FILTER</v-btn> -->
            <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="btn outline-btn elevation-0 mx-2 pl-4 pr-6"
              rounded
              depressed
              v-bind="attrs"
              v-on="on"
            >
            <v-img
            v-bind="attrs" 
            v-on="on" 
            :src="require(`@/assets/svg/sort.svg`)"
            
            />              
              <span>SORT</span>
            </v-btn>
          </template>
          <v-list>
            <v-list-item 
              v-for="option in sortOptions" 
              :key="option.value" 
              @click="selectSortOption(option.value)"
              :class="{'selected-sort-option': selectedSort === option.value}"
            >
              <v-list-item-title>
                {{ option.label }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
            <v-btn class="border-button mx-3" outlined rounded :disabled="!$store.state.role.learningObjective.delete || selected.length === 0"
              @click="deleteDialog = true"><v-icon class="pr-2">mdi-trash-can-outline</v-icon>Delete</v-btn>
            <!-- <v-btn class="primary mx-2"
            rounded><v-icon>mdi-export</v-icon>Export</v-btn> -->
            <v-btn depressed rounded outlined class="border-button mx-3" @click="downlaodRoles"><v-icon>mdi-import
                mdi-rotate-90</v-icon></v-btn>

            <v-btn :disabled="!$store.state.role.learningObjective.create" @click="dialog = true, newLOBankCreate()"
              class="accent mx-3 white--text" depressed rounded><v-icon class="pr-2">mdi-plus</v-icon>Create
            </v-btn>

          </v-row>
        </v-col>
      </v-row>
      <v-data-table fixed-header height="calc(100vh - 230px)" class="rounded-table"  v-model="selected"
        :loading="dataTableLoading" loading-text="Loading Skills" :headers="headers" :items="tableData" show-select
        :disable-sort="true"
        :items-per-page="options.itemsPerPage"
        :server-items-length="count"
        :options.sync="options"
        :single-select="singleSelect"
        hide-default-footer
        ref="myTable"
        :class=" isScrollable ? 'frozen-columns-table' : ''"
        >
        <template v-slot:[`item.createdOn`]="{ item }">
          {{ getDate(item.createdOn) }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn :disabled="$store.state.role.learningObjective.update" icon class="mr-2 pa-4" @click="updateData(item)">
            <img width="36px" height="36px" class="cursor" src="../../assets/edit.svg" />
          </v-btn>
        </template>
        <template v-slot:no-results>
          <div class="mt-16 pt-16">
            <img
          src="../../assets/noResultFound.svg"/>
          </div>

      </template>
            <template v-slot:footer="{ props }">
              <table-footer
                :pagination="props.pagination"
                :options="props.options"
                @update-options="onFooterUpdate"
              />
            </template>
      </v-data-table>
      <v-dialog v-model="deleteDialog" class="cdz" max-width="366px" persistent>
        <v-card fluid>
          <v-container fluid class="pa-0">
            <v-card-text class="text-center">
              <v-container></v-container>
              <v-avatar color="background" size="90"><v-icon size="65">mdi-trash-can-outline</v-icon></v-avatar>

              <p class="text-h5 pt-6 pb-0">Delete LOBank</p>
              <p class="text-disabled grey--text text-subtitle-1 pt-3" color="rgba(0, 0, 0, 0.6)" disabled>This action
                will
                permanently delete the item . This cannot be undone</p>

              <div class="d-flex justify-space-between pt-4 pb-2" fluid> <v-btn depressed class="background black--text"
                  large width="157px" rounded @click="deleteDialog = false">CANCEL</v-btn> <v-btn
                  class="accent white--text" depressed large width="157px" rounded :loading="dLoading"
                  @click="deleteData(selected)">DELETE</v-btn></div>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>

      <v-dialog v-model="errorDialog" max-width="366px" class="cdz" persistent>
        <v-card>
          <v-container fluid class="pa-8">
            <v-card-text class="text-center">
              <v-icon color="error" size="96">mdi-close-circle-outline</v-icon>
              <p class="text-h5 pt-2 font-weight-medium">Error</p>
              <p class="text-h6 py-3 font-weight-regular">{{ errorMessage }}</p>
              <v-btn class="primary" large width="157px" rounded @click="errorDialog = false">Ok</v-btn>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>

      <v-dialog v-model="deleteSuccessDialog" max-width="366px" class="cdz" persistent>
        <v-card>
          <v-container fluid class="pa-8">
            <v-card-text class="text-center">
              <v-icon color="#228B22" size="96">mdi-check-circle-outline</v-icon>
              <p class="text-h5 font-weight-bold py-4">LO Bank Deleted</p>
              <div class="d-flex justify-center">
                <v-btn class="primary-btn btn" large width="157px" rounded @click="deleteSuccessDialog = false">Ok</v-btn>
            </div>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>

      <v-dialog v-model="successDialog" max-width="366px" class="cdz" persistent>
        <v-card>
          <v-container fluid class="pa-8">
            <v-card-text class="text-center">
              <v-icon color="success" size="96">mdi-check-circle-outline</v-icon>
              <p class="text-h5 py-4">LO {{ formbtnValue() }}</p>
              <div class="d-flex justify-center">
                <v-btn class="primary-btn btn" large width="157px" rounded @click="successDialog = false">Ok</v-btn>
              </div>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>
    </div>

    <!-- Notification Dialog -->
    <v-dialog v-model="notificationDialog" class="cdz" max-width="380px">
      <Notification @close-dialog="notificationDialog = false" />
    </v-dialog>

  </div>
</template>
<script>
import LoBankController from "@/controllers/LoBankController";
import AuthService from "../../services/AuthService";
import Papa from "papaparse";
import Notification from "../Notification.vue";
import MastersDropdownComponent from "@/components/MastersDropdownComponent.vue";
import { getDateFromTimestamp } from "@/helpers/utils";
import isTableScrollableMixin from "@/mixins/isTableScrollableMixin";
import { debounce } from "lodash";


export default {
  name: "LoBankView",
  mixins: [isTableScrollableMixin ],
  components: {
    Notification, MastersDropdownComponent
  },
  data() {
    return {
      notificationDialog: false,
      debouncedGetLO: null,
      options: {},
      pageSize: 10,
      page: 1,
      count: 0,
      errorDialog: false,
      successDialog: false,
      deleteSuccessDialog: false,
      errorMessage: "",
      dialog: false,
      dialogTitle: "Dialog Title",
      title: null,
      description: null,
      formbtnBool: false,
      singleSelect: false,
      deleteDialog: false,
      dLoading: false,
      lOCode: null,
      loading: false,
      selected: [],
      LOData: null,
      search: '',
      searchBool: false,
      editId: null,
      dataTableLoading: true,
      sortCol:"name",
      sortOrder: "asc", // Default sort order (asc or desc)
      selectedSort: "LoAsc", // Default selected sort option
      sortOptions: [
        { value: "LoAsc", label: "Learning Objective - Ascending (A-Z)" },
        { value: "LoDesc", label: "Learning Objective - Descending (Z-A)" },
        { value: "dateNewest", label: "Date - Newest" },
        { value: "dateOldest", label: "Date - Oldest" },
      ],
      headers: [
        { text: "LO Code", value: "lOCode" },
        { text: "LO Title", value: "name" },
        // { text: "Subject Category", value: "subjectCategory" },
        { text: "Created  On", value: "createdOn" },
        { text: "Actions", value: "actions" },
      ],
      tableData: [],
      rules: {
        required: (value) => !!value || "Field is required",
      },
    };
  },
  watch: {
    search(newValue) {
      // Update URL when search changes
      this.$router.replace({
        query: {
          ...this.$route.query,
          search: newValue || undefined
        }
      }).catch(() => {});
      this.search = newValue ?? "";
      this.options.page = 1;
      this.debouncedGetLO();
    },
  },
  methods: {
    logout() {
      AuthService.logout();
      this.$router.push("/login");
    },

    async downloadCSV(csvData, fileName) {

      const csv = Papa.unparse(csvData);


      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

      if (navigator.msSaveBlob) {

        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {

          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },

    async downlaodRoles() {
      const fileName = 'lobank.csv';
      const LoBank = await LoBankController.getLO()
      this.downloadCSV(LoBank, fileName);
    },

    // async searchData(search){
    //   const response = await LoBankController.searchLoBank(
    //     this.pageSize,
    //     this.page,
    //     search,
    //   );
    //   console.log(response.data);
    //   console.log(this.searchBool);
    //   this.count = response.data.data.count;
    //   this.tableData = response.data.data.rows;
    // },
    getDate(timeStamp) {
      return getDateFromTimestamp(timeStamp);
    },
    updateData(item) {
      this.editId = item.id;
      this.formbtnBool = true; // change update/create btn value
      console.log("data id", item.id);
      this.dialog = true;
      this.lOCode = item.lOCode;
      this.title = item.name;
      this.description = item.description
    },
    filter: function (evt) {
      evt = (evt) ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    newLOBankCreate() {
      this.lOCode = '';
      this.title = '';
      this.description = "";
      this.formbtnBool = false
    },

    formbtn() {
      return this.formbtnBool === false ? "Create" : "Update";
    },
    formbtnValue() {
      return this.formbtnBool === false ? "Created" : "Updated";
    },
    selectSortOption(sortOption) {
      this.selectedSort = sortOption;
      switch (sortOption) {
        case "LoAsc":
          this.sortCol = "name";
          this.sortOrder = "asc";
          break;
        case "LoDesc":
          this.sortCol = "name";
          this.sortOrder = "desc";
          break;
        case "dateNewest":
          this.sortCol = "createdOn";
          this.sortOrder = "desc";
          break;
        case "dateOldest":
          this.sortCol = "createdOn";
          this.sortOrder = "asc";
          break;
        default:
          this.selectedSort = "LoAsc";
          this.sortCol = "name";
          this.sortOrder = "asc";
      }
      this.options.page = 1;
      this.getLO();
    },
    async saveInputs() {
      if (this.$refs.form.validate()) {
        var res;
        this.loading = true;
        // checking case for update/create
        if (this.formbtnBool == false) {
          const response = await LoBankController.createLO(
            this.lOCode,
            this.title,
            this.description
          );
          console.log(response);
          res = response;
        } else {
          const response = await LoBankController.updateLO(
            this.lOCode,
            this.title,
            this.description,
            this.editId
          );
          console.log(response);
          res = response
        }
        // Close the dialog
        this.formbtnBool == false;
        this.dialog = false;
        if (res.data.flag) {
          this.successDialog = true;
        } else {
          this.errorDialog = true;
          this.errorMessage = res.data.error;
        }
        this.getLO();
        this.loading = false;
      }
    },

    async deleteData(data) {
      //   if(data.length==1){
      //   this.dLoading = true;
      //   const response = await LoBankController.deleteLO(data[0].id);      
      //   // if block for check delete status
      //   if (response.data.flag) {
      //     this.getLO();       
      //   }
      //   else {
      //     alert(response.data.error)
      //   }

      // }else{
      //   // else block for bulk delete
      //   var ids="";
      //     for(var i=0;i<data.length;i++){
      //       ids = ids + data[i].id;
      //         if( i != data.length - 1 ) {
      //             ids = ids + ","
      //         }
      //     }
      var ids = [];
      data.forEach((dataDelete) => {
        ids.push(dataDelete.id)
      })
      this.dLoading = true;
      const response = await LoBankController.deleteBulkLO(ids);
      if (response.data.flag) {
        this.getLO();
        this.deleteDialog = false;
        this.dLoading = false
        this.selected = []
      }
      else {
        alert(response.data.error)
        this.getLO();
        this.deleteDialog = false;
        this.dLoading = false
        this.selected = []
      }
      this.deleteDialog = false;
      this.dLoading = false;
      this.deleteSuccessDialog = true;
    },
    sortByAlphabet(array, key) {
      array.sort(function (a, b) {
        var nameA = a[key].toUpperCase(); // Convert to uppercase to ensure case-insensitive sorting
        var nameB = b[key].toUpperCase();

        if (nameA < nameB) {
          return -1;
        }

        if (nameA > nameB) {
          return 1;
        }

        return 0;
      });
      return array;
    },
    async onFooterUpdate(newOptions) {
      this.options = { ...this.options, ...newOptions };
      await this.$nextTick();
      await this.getLO();
    },
    async getLO() {
      this.page = this.options.page;
      this.pageSize = this.options.itemsPerPage;
      const params = {
        page: this.options.page,
        pageSize: this.options.itemsPerPage,
        search: this.search,
        sortCol: this.sortCol,
        sortOrder: this.sortOrder,
      }
      const query = "?"+(new URLSearchParams(params).toString());
      const response = await LoBankController.getLOByPagination(
        query
      );
      if (response.status == 200) {
        this.dataTableLoading = false
        this.tableData = response.data.learningObjective;
        this.count = response.data.count;
        // console.log(this.LOData.rows);
        // if (response.data.learningObjective.length > 0) {
        //   this.LOData = response.data.learningObjective;
        //   this.tableData = this.LOData;
        // }
      }
      else {
        this.dataTableLoading = false
        // alert(response.data.error);
        alert("Something went wrong")
      }

    },
  },
  created() {
    this.debouncedGetLO = debounce(this.getLO, 500);
    this.getLO();
    this.$store.state.breadcrumb = "LO Bank";
  },
};
</script>
<style></style>